'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.default = createSubtreeLifecycleMethods;

var _invariant = require('nanotools/lib/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _combineReducers = require('nanotools/lib/combineReducers');

var _combineReducers2 = _interopRequireDefault(_combineReducers);

var _mountComponent = require('../mountComponent');

var _createComponent = require('../createComponent');

var _createComponent2 = _interopRequireDefault(_createComponent);

var _identityReducer = require('nanotools/lib/identityReducer');

var _identityReducer2 = _interopRequireDefault(_identityReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createSubtreeLifecycleMethods(getSubtree, cWM, cDM, cWU) {
	return {
		componentWillMount: function componentWillMount() {
			var _this = this;

			var subtreeDefinition = getSubtree.call(this);
			var subtreeKeys = (0, _keys2.default)(subtreeDefinition);
			var reducerMap = {};
			// Remember the keys for later unmounting.
			this.__subtreeKeys = subtreeKeys;

			// Create and invoke willMount for each subcomponent
			subtreeKeys.forEach(function (k) {
				// Verify this won't shadow something on the class.
				if (process.env.NODE_ENV !== 'production') {
					(0, _invariant2.default)(_this[k] == null, 'redux-component of type ' + _this.displayName + ' (mounted at location ' + _this.path + ') has a subtree key named "' + k + '" that would shadow a property of the parent component.');
				}

				// Conjure the child component
				var component = (0, _createComponent2.default)(subtreeDefinition[k]);
				_this[k] = component;
				component.__willMount(_this.store, _this.path.concat([k]), _this);
				reducerMap[k] = component.reducer;
			});

			// Create the combined reducer
			this.__subtreeReducer = (0, _combineReducers2.default)(reducerMap);

			// redux-components lifecycle contract requires this to be called in postorder (after children)
			if (cWM) cWM.call(this);
		},
		componentDidMount: function componentDidMount() {
			var _this2 = this;

			this.__subtreeKeys.forEach(function (k) {
				return (0, _mountComponent.didMountComponent)(_this2[k]);
			});
			if (cDM) cDM.call(this);
		},
		componentWillUnmount: function componentWillUnmount() {
			var _this3 = this;

			this.__subtreeKeys.forEach(function (k) {
				return (0, _mountComponent.willUnmountComponent)(_this3[k]);
			});
			if (cWU) cWU.call(this);
			// Remove reducers after unmount lifecycle.
			this.__subtreeReducer = _identityReducer2.default;
			this.__subtreeKeys.forEach(function (k) {
				return delete _this3[k];
			});
			delete this.__subtreeKeys;
		}
	};
}